export default __webpack_public_path__ + "static/media/9.cf884a6c.jpg";